import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

import Box from '@mui/material/Box';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import styles from "../../../../services/ServicesSections.module.scss";
// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <Box 
        sx={{
          '& ol li': {
            fontSize: '1.188rem'
          }
        }}
      >
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            Fix Skitch Not Working on Mac Issues
          </h3>
          <p>
            Is skitch not working on your mac? Skitch is one of our favourite
            tools here at Tribalism... except when it crashed on every mac
            update. For the latest Big Sur May 2021 update see how to get it
            working again here...
            <br />
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2021-05-13-skitch/skitch-not-working-on-mac-small-resize.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Look familiar?</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Google will show you what it thinks are "helpful" forum posts..
            (hint they are not helpful forum posts)
          </h3>
          <p>
            <br />
            Most "tutorials" you'll find claiming to fix skitch not working on
            mac issues are just glorified fluff pieces or that dont deal wit
            hthe issue at all - or are an annoying series of random forums posts
            on either apple support or - more annoyingly (because you need to
            create an account and login first to even read) - Evernote forums -
            yeah Skitch is owned by Evernote... who knew? For some reason
            everytime Mac OS updates - any app (well mainly Skitch it seems
            like) that usese "screen recording" loses the plot... Skitch will
            only start recording the background
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Heres the actual fix</h3>
          <p>
            Anyways here is the fix{" "}
            <i>
              (the full fix not the half assed fixes you'll find online from 2
              years ago..)
            </i>
          </p>
          <ol>
            <li>Go to Settings</li>
            <li>Choose Security & Privacy</li>
            <li>Choose the Privacy Tab</li>
            <li>Scroll down to Screen Recording</li>
            <li>
              Tick the checkbox next to Skitch app {"<-"} if no checkbox or not
              appearing, click the +/- sign below the box to add the Skitch app
              to the list
            </li>
          </ol>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "600px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2021-05-13-skitch/skitch-not-working-on-mac2-small-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>
        <GridItem xs={12} sm={8} md={8}>
          <br></br>
          <ol start="7">
            <li>Now for the coup de grace....</li>
            <li>
              THERE IS "ANOTHER" SKITCH APP YOU HAVE TO TICK HERE - IT IS
              CALLED "SKITCH HELPER".
            </li>
          </ol>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "600px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2021-05-13-skitch/skitch-not-working-on-mac2-small-resize.webp"
              alt="..."
              className={imgClasses}
            />
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          
          <ol start="9">
            <br></br>
            <li>
              Tick allow screen recording for this app also - and viola!
            </li>
          </ol>

          <p>
            Its working again and{" "}
            <strong>
              you dont have to waste 1.5hrs like we didnt sifting through
              irrelevant google search results
            </strong>{" "}
            and crappy forums with irrelevant answers. Please share far and wide
            with afflicted people - to spare them the pain we went through!
            Cheers!
            <br></br>
            <br></br>
          </p>
        </GridItem>
      </GridContainer>
      </Box>
    </div>
  );
}
